(function () {
  'use strict';

  var COLS_CLASS = 'breakout-nav__mega-links--cols-3';
  var COMPACT_CLASS = 'breakout-nav__dropdown--mega-compact';

  function linksOverflow(links) {
    return links.scrollHeight > links.clientHeight + 1;
  }

  function syncMegaMenuLayout(panel) {
    if (
      !panel ||
      panel.classList.contains('breakout-nav__dropdown--brands') ||
      panel.classList.contains('breakout-nav__dropdown--bras') ||
      panel.classList.contains('breakout-nav__dropdown--sale') ||
      panel.classList.contains('breakout-nav__dropdown--new-arrivals')
    ) {
      return;
    }

    var links = panel.querySelector('.breakout-nav__mega-links');
    if (!links) return;

    panel.classList.remove(COMPACT_CLASS);
    links.classList.remove(COLS_CLASS);

    window.requestAnimationFrame(function () {
      links.classList.add(COLS_CLASS);

      window.requestAnimationFrame(function () {
        if (linksOverflow(links)) {
          panel.classList.remove(COMPACT_CLASS);
          return;
        }

        links.classList.remove(COLS_CLASS);
        panel.classList.add(COMPACT_CLASS);

        window.requestAnimationFrame(function () {
          if (linksOverflow(links)) {
            panel.classList.remove(COMPACT_CLASS);
          }
        });
      });
    });
  }

  function syncAllPanels() {
    document.querySelectorAll('[data-breakout-mega-panel]').forEach(syncMegaMenuLayout);
  }

  function init() {
    document.querySelectorAll('.breakout-nav__item--dropdown').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var panel = item.querySelector('[data-breakout-mega-panel]');
        if (panel) syncMegaMenuLayout(panel);
      });

      item.addEventListener('focusin', function () {
        var panel = item.querySelector('[data-breakout-mega-panel]');
        if (panel) syncMegaMenuLayout(panel);
      });
    });

    syncAllPanels();
    window.addEventListener('resize', syncAllPanels, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncAllPanels);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Desktop mega menu panels, revamped look.

  z__jsMegaMenu clones each Mega Menu section into its nav item, and the item is
  position:relative — so the panel opens under its own trigger's row (which matters
  once the links wrap onto a second row) but is also horizontally bound to a
  ~100px-wide item. Left as-is it renders as a 544px box centred on the item, which
  runs off-screen for the right-hand items.

  Same fix the revamped nav used (see breakout-header.js): correct each panel's
  left/width per item so it spans the full nav width instead. The card styling on
  top of that lives in custom.css.
*/
(function () {
  'use strict';

  /* The row, not the <ul> inside it: the list shrink-wraps its links, while the row
     spans the header container - which is the width the revamped panels had. */
  var NAV_SELECTOR = '.breakout-header__nav-row';
  var ITEM_SELECTOR = '.header__item.has-mega-menu';

  function positionPanels() {
    var nav = document.querySelector(NAV_SELECTOR);
    if (!nav) return;

    var navRect = nav.getBoundingClientRect();
    if (!navRect.width) return;

    nav.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      var panel = item.querySelector('.mega-menu__section .mega-menu');
      if (!panel) return;

      var itemRect = item.getBoundingClientRect();
      panel.style.left = Math.round(navRect.left - itemRect.left) + 'px';
      panel.style.width = Math.round(navRect.width) + 'px';
      /* the stylesheet's translateX(-50%) centring has to be neutralized inline —
         it outranks any class-level transform on the panel */
      panel.style.transform = 'none';
    });
  }

  function onPointer(event) {
    if (event.target.closest && event.target.closest(NAV_SELECTOR)) positionPanels();
  }

  var positionTimer;
  function schedulePosition() {
    window.clearTimeout(positionTimer);
    positionTimer = window.setTimeout(positionPanels, 100);
  }

  /* Panels are cloned in by the mega menu section's own init, so re-measure on the
     first hover as well as on load. */
  document.addEventListener('mouseover', onPointer, true);
  document.addEventListener('focusin', onPointer, true);
  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('load', positionPanels);

  /* Theme editor: editing a Mega menu re-renders the section, which re-clones a
     fresh (unmeasured) panel into the nav and force-shows it. Measure the new one. */
  ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(
    function (event) {
      document.addEventListener(event, schedulePosition);
    }
  );

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(positionPanels);
  }
})();
